var React = require('react');

function CardDetail (props) {
    return React.createElement("svg",props,React.createElement("g",{"enableBackground":"new"},React.createElement("path",{"transform":"matrix(1,0,0,1,-11590.936,-1264.0888)","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","fill":"none","stroke":"#53e0aa","d":"M 11592.999 1272.5564 L 11604.296 1265.5889 L 11615.595 1272.5564 L 11626.892 1265.5889 L 11638.19 1272.5564 L 11649.485 1265.5889 L 11660.784 1272.5564 L 11672.081 1265.5889 L 11683.378 1272.5564 L 11694.675 1265.5889 L 11705.974 1272.5564 "})));
}

CardDetail.defaultProps = {"version":"1.1","width":"118pt","height":"11pt","viewBox":"0 0 118 11"};

module.exports = CardDetail;

CardDetail.default = CardDetail;
